
function About() {
    return (
      <main>
        <div className="bg-white py-12 px-6">
      <div className="max-w-3xl mx-auto text-center">
        {/* About Us Heading */}
        <h4 className="text-3xl font-extrabold text-gray-900 mb-6">
          ABOUT US
        </h4>

        {/* About Us Description */}
        <p className="text-gray-700 text-justify leading-relaxed mb-6">
          Welcome to the Bhattadev University Student Information Management System! Seamlessly connecting students, faculty, and administration for a smoother academic experience.
        </p>

       
      </div>
    </div>
      </main>
    )
  }
  
  export default About